module.exports = __webpack_public_path__ + "ad.dd8088c3.png";